import { render } from "./DealerTabs.vue?vue&type=template&id=7f5ac464&scoped=true"
import script from "./DealerTabs.vue?vue&type=script&lang=js"
export * from "./DealerTabs.vue?vue&type=script&lang=js"

import "./DealerTabs.vue?vue&type=style&index=0&id=7f5ac464&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5ac464"]])

export default __exports__